<template>

    <div>

        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', 'orders-options' ) ">

            <font-awesome-icon icon="list-ol" size="3x" />
            Orders
        </button>
        <button class="options-btn btn-blue" @click=" $emit( 'switchTo', 'menu-options' ) ">

            <font-awesome-icon icon="utensils" size="3x" />
            Menu
        </button>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'orders-and-menu',
        methods: {

        },
        components: {

            FontAwesomeIcon
        }
    }

</script>

<style scoped>

</style>